import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';

export const ButtonStyled = styled(Button, {
  name: 'ButtonStyled',
})(({ theme }) => ({
  marginRight: theme.spacing(2),
}));
